import { Text } from "react-native-paper";
import Box from "../Box";
import MarkdownRenderer from "../MarkdownRenderer";
import ProductIcon from "../ProductIcon";

export type ProductIconSectionProps = {
	url?: string;
	numItems?: number;
	selectedDate?: string;
	fromHomePage?: boolean;
	subheading?: string;
	title?: string;
	description?: string;
	appFont?: string;
};

const ProductIconSection = ({
	url,
	subheading,
	title,
	description,
	appFont,
}: ProductIconSectionProps) => {
	return (
		<>
			<Box alignItems="center">
				<ProductIcon image={url || ""} size={128} showBorder={false} />
			</Box>
			{subheading ? (
				<MarkdownRenderer
					text={subheading}
					variant="explanation"
					textAlign="center"
					appFont={appFont}
					fontSize={16}
				/>
			) : (
				<Box alignItems="center">
					{title ? (
						<Text variant="titleMedium" style={{ textAlign: "center" }}>
							{title}
						</Text>
					) : null}
					{description ? (
						<Text variant="bodySmall" style={{ textAlign: "center" }}>
							{description}
						</Text>
					) : null}
				</Box>
			)}
		</>
	);
};

export default ProductIconSection;
